var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container",class:{
    'app-container--drawer-header': _vm.isDrawer,
    'app-container--back-header': !_vm.isDrawer,
    'app-container--navigation-footer': _vm.showNavigationFooter,
    'app-container--mismatch': _vm.mismatch,
    'app-container--fullwidth': _vm.fullWidth,
  }},[(_vm.mismatch)?_c('img',{staticClass:"app_logoutimg",attrs:{"src":"/user/logout/image"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-contents",class:{ 'container': _vm.container }},[_vm._t("default")],2),_vm._v(" "),(_vm.fixedBgStatus)?_c('fixed-background',{attrs:{"all-height":_vm.allHeight,"scroll-position":_vm.scrPos,"fixed-bg-status":_vm.fixedBgStatus}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1c7b0b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/AppContainer.vue
// module id = null
// module chunks = 